import { Module, Mutation, Action } from "vuex-module-decorators";
import { BountyStatusEnums } from "@/enums/growth";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryRequest, handlePaginationData } from "@/utils/request";
import {
  getMyBonusAccount,
  queryMyBusinessList,
  queryMyBusinessListSum,
  getMyBusinessListSum,
  queryDtFlow,
  queryTbrBonusAccount
} from "@/graphql/bounty.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { formatByDate, getDateBefore36 } from "@/utils/common/date";
import type { PaginationDataState } from "@/types";

const defaultSearchCondition = () => ({ _type: "" });
export interface BountyDetailState extends PaginationDataState {
  statusTab: string;
  searchCondition: any;
}

@Module({ name: "BountyDetailModule", namespaced: true })
export default class BountyDetailModule
  extends PaginationModule<BountyDetailState, RootState>
  implements BountyDetailState {
  public listData: any[] = [];
  public statusTab: string = BountyStatusEnums.CHECKED; // 头部状态选择
  public searchCondition: any = defaultSearchCondition(); // 筛选条件
  public openFilterFlag: boolean = false; // 打开筛选模块
  public timeSumMap = {}; // 时间统计集合
  public filterData: any = []; // 筛选条件数据
  public userBounty: any = {};

  @Mutation
  setFilterDataMutation(data: any[]) {
    this.filterData = data || [];
  }
  @Mutation
  setUserBountyMutation(data: any) {
    this.userBounty = data || {};
  }

  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }
  @Mutation
  setStatusTabMutation(data: string) {
    this.statusTab = data ?? BountyStatusEnums.CHECKED;
  }
  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = defaultSearchCondition();
    } else {
      this.searchCondition[key] = value;
    }
  }
  @Mutation
  setOpenFilterFlagMutation(data: boolean) {
    this.openFilterFlag = data ?? false;
  }
  @Mutation
  setTimeSumMapMutation({ key = "", value = "" } = {}) {
    if (!(key && value)) {
      this.timeSumMap = {};
    } else {
      this.timeSumMap[key] = value;
    }
  }

  @Action
  async queryListAction({ callback }) {
    const {
      state: {
        statusTab,
        searchCondition,
        paginationData,
        paginationData: { pageNum, pageSize }
      },
      commit
    } = this.context;
    const [start, end] = getDateBefore36();
    let interfaceUrl: any, variables: any;
    if (statusTab === BountyStatusEnums.CHECKED) {
      interfaceUrl = queryDtFlow;
      variables = {
        input: {
          businessType: searchCondition._type || undefined,
          fundType: "02", // 可用
          startTime: searchCondition.startTime || formatByDate(start),
          endTime: searchCondition.endTime || formatByDate(end)
        }
      };
    } else {
      interfaceUrl = queryMyBusinessList;
      variables = {
        accountBusiness: {
          businessStatus: statusTab,
          // ...searchCondition,
          startTime: searchCondition.startTime || formatByDate(start),
          endTime: searchCondition.endTime || formatByDate(end),
          // _type: undefined, // 删除字段，类型筛选
          fundType: searchCondition._type || undefined
        }
      };
    }
    let { data = [], totalCount } = handlePaginationData(
      await queryRequest({
        query: interfaceUrl,
        variables: {
          pageInput: { pageNum, pageSize },
          ...variables
        }
      })
    );
    data = await callback(data);
    commit(
      pageNum === 1 ? "saveListDataMutation" : "addListDataMutation",
      data
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  async queryFilterDataAction() {
    const data = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: {
          ddCode: "TBR_BONUS_SOURCE", // 奖励金筛选
          lang: window.i18n.locale
        }
      }
    });
    this.context.commit("setFilterDataMutation", data);
  }

  // 查询用户奖励金
  @Action
  async getMyBonusAccountAction(variables) {
    const data = await queryRequest({
      query: queryTbrBonusAccount,
      variables
    });
    this.context.commit("setUserBountyMutation", data);
  }

  @Action
  async queryMyBusinessListSumAction(variables: Object) {
    const data = await queryRequest({
      query: queryMyBusinessListSum,
      variables
    });
    data.forEach(o => {
      this.context.commit("setTimeSumMapMutation", { key: o.month, value: o });
    });
  }

  @Action
  async queryMyBusinessListSumAction2(variables: Object) {
    const data = await queryRequest({
      query: getMyBusinessListSum,
      variables
    });
    data.forEach(o => {
      this.context.commit("setTimeSumMapMutation", { key: o.month, value: o });
    });
  }
}
